import { memo } from "react"
import HexagonSwirl from '../assets/animations/hexagonSwirl.json';
import Lottie from "lottie-react";

// Module-level memoization - shared across ALL instances
const STATIC_ANIMATION_DATA = HexagonSwirl;

// Base style that never changes
const BASE_STYLE = {
  position: 'absolute' as const,
  top: '-1px',
  transform: 'translate3d(0, 0, 0)',
  willChange: 'transform',
  backfaceVisibility: 'hidden' as const,
} as const;

interface AIAgentBorderProps {
  width?: number;
  height?: number;
}

const AIAgentBorder: React.FC<AIAgentBorderProps> = ({width=50, height=50}) => {
  // Only create size-specific styles when width/height actually change
  const sizeStyle = {
    ...BASE_STYLE,
    width: `${width}px`,
    height: `${height}px`,
  };

  return (
    <Lottie
      animationData={STATIC_ANIMATION_DATA}
      loop={true}
      style={sizeStyle}
    />
  )
}

export default memo(AIAgentBorder)
